// export this package's api
import DialogWrap from './DialogWrap';
export default DialogWrap;
